var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.06 2H6.91C4.48 2 2.5 3.98 2.5 6.41V12.91V13.11C2.5 15.55 4.48 17.52 6.91 17.52H10.75C11.3 17.52 11.75 17.97 11.75 18.52V19.49C11.75 20.04 11.3 20.49 10.75 20.49H8.33C7.92 20.49 7.58 20.83 7.58 21.24C7.58 21.65 7.91 22 8.33 22H16.68C17.09 22 17.43 21.66 17.43 21.25C17.43 20.84 17.09 20.5 16.68 20.5H14.26C13.71 20.5 13.26 20.05 13.26 19.5V18.53C13.26 17.98 13.71 17.53 14.26 17.53H18.07C20.51 17.53 22.48 15.55 22.48 13.12V12.92V6.42C22.47 3.98 20.49 2 18.06 2Z",
    fill: "#0C5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorIcon);
export default __webpack_public_path__ + "static/media/monitor-icon.2e349ef212116f88e7eae59893c908b9.svg";
export { ForwardRef as ReactComponent };